<template>
  <Scroll :height="height">
    <div style="position:relative; margin-top:15px;">
      <Form ref="formStep1" :label-width="120" :model="formItem">
        <FormItem label="设备检索条件：">
          <Select v-model="formItem.selectCondition" @on-change="changeCondition">
            <Option value="idCard">身份证号</Option>
            <Option value="meterId">设备编号</Option>
            <Option value="meterType">设备类型</Option>
            <Option value="address">地址</Option>
          </Select>
        </FormItem>
        <FormItem label=" 输入或选择条件：">
          <Select
            v-model="formItem.selectMeterType"
            v-if="showSelectMeterType"
            @on-change="step1CheckNext"
          >
            <Option v-for="(item) in meterTypeData" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
          <Cascader
            :data="addressData"
            change-on-select
            filterable
            transfer
            @on-change="choiceAll"
            v-if="showAddressData"
          ></Cascader>
          <Input
            v-model="formItem.inputIdCard"
            @on-change="step1CheckNext"
            placeholder="请输入身份证号"
            v-if="showInputIdCard"
          ></Input>
          <Input
            v-model="formItem.inputMeterId"
            @on-change="step1CheckNext"
            placeholder="请输入设备编号"
            v-if="showInputMeterId"
          ></Input>
        </FormItem>
      </Form>
    </div>
  </Scroll>
</template>
<script>
export default {
  created() {
    this.request();
  },
  data() {
    return {
      showStep1: true,
      height: document.body.clientHeight * 0.7,
      showSelectMeterType: false,
      showAddressData: false,
      showInputIdCard: false,
      showInputMeterId: false,
      addressDataSelect: "",
      meterTypeData: [],
      addressData: [],
      formItem: {
        input: "",
        select: "",
        selectName: "",
        selectCondition: "",
        radio: "male",
        checkbox: [],
        switch: true,
        date: "",
        time: "",
        slider: [20, 50],
        textarea: ""
      },
      opType: global.commandop
    };
  },
  methods: {
    step1CheckNext() {
      if (
        this.formItem.selectCondition != null &&
        this.formItem.selectCondition != "" &&
        ((this.formItem.selectMeterType != null &&
          this.formItem.selectMeterType != "") ||
          (this.formItem.inputIdCard != null &&
            this.formItem.inputIdCard != "") ||
          (this.formItem.inputMeterId != null &&
            this.formItem.inputMeterId != "") ||
          (this.addressDataSelect != null && this.addressDataSelect != ""))
      ) {
        this.nextEvent(false);
      } else {
        this.nextEvent(true);
      }
    },
    nextEvent(param) {
      this.disabledButtonNext = param;
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$Message.success("Success!");
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    changeCondition() {
      this.showSelectMeterType = false;
      this.showAddressData = false;
      this.showInputIdCard = false;
      this.showInputMeterId = false;
      this.formItem.selectMeterType = null;
      this.addressDataSelect = null;
      this.formItem.inputIdCard = null;
      this.formItem.inputMeterId = null;
      switch (this.formItem.selectCondition) {
        case "meterId":
          this.showInputMeterId = true;
          break;
        case "idCard":
          this.showInputIdCard = true;
          break;
        case "meterType":
          this.showSelectMeterType = true;
          break;
        case "address":
          this.showAddressData = true;
          break;
      }
    },
    choiceAll(data) {
      //console.log(data);  //当复选框选中时则会打印出选中的内容
      var temp = "";
      for (var i = 0; i < data.length; i++) {
        //console.log(temp);
        //console.log(data[i].nodeKey);
        temp =
          temp == ""
            ? data[i].nodeKey.toString()
            : temp + "," + data[i].nodeKey.toString();
      }
      this.addressDataSelect = temp;
    },
    changeIdCard() {},
    changeMeterId() {},
    changeMeterType() {},
    onChangeSelect(param) {
      this.$emit("listenToChild1Event", param);
      this.formItem.selectName = param;
    },
    request() {
      var that = this;
      $.ajax({
        url: "/api/getAddressTree",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.addressData = data.body[0].children;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });

      $.ajax({
        url: "/api/getMeterTypeInfo",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.meterTypeData = data.body.resultList;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    }
  }
};
</script>